import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { GridPDFExport } from '@progress/kendo-react-pdf';
import { SupplierSaleItem } from '../SalesPage';

interface SalesPDFExportProps {
    data: SupplierSaleItem[];
    supplierName: string;
    onRef: (exporter: GridPDFExport | null) => void;
}

export const SalesPDFExport: React.FC<SalesPDFExportProps> = ({ data, supplierName, onRef }) => {
    return (
        <GridPDFExport
            ref={onRef}
            margin="1cm"
            fileName={`${supplierName}_Sales_${new Date().toLocaleDateString()}`}
        >
            <Grid data={data}>
                <Column field="item_description" title="Item Description" />
                <Column field="item_number" title="Item Number" />
                <Column field="item_ndc" title="Item NDC" />
                <Column field="account_name" title="Account Name" />
                <Column field="account_number" title="Account Number" />
                {/* <Column field="item_uom" title="Item UOM" /> */}
                <Column field="purchase_order_number" title="PO Number" />
                <Column field="purchase_order_date" title="PO Date" />
                <Column field="invoice_date" title="Invoice Date" />
                <Column field="invoice_number" title="Invoice Number" />
                <Column field="invoice_quantity" title="Invoice Quantity" />
                <Column field="item_unit_price" title="Item Price" />
                <Column field="item_total_price" title="Total Sales" />
            </Grid>
        </GridPDFExport>
    );
}; 